/**
 * Handle Sticky content animations
 *
 * @return {void}
 */

const $window = $(window);

export const stickyContent = () => {
  $('.js-sticky-container').each(function () {
    const $container = $(this);
    const $sidebar = $container.find('.js-sticky-content');
    const $sidebarInner = $sidebar.find('.js-sticky-content-inner');
    let sidebarHeight = $sidebarInner.outerHeight();

    if ($(window).outerWidth() > 1023) {
      $container.css({
        'min-height': sidebarHeight
      });
    } else {
      $container.css({
        'min-height': 'auto'
      });
    }
  });
};

$window.on('load resize', function () {
  stickyContent();
});
